import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { emailValidator} from "../utils/app-validators";
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  public form: FormGroup;
  error: string;
  public id;
  loading = false;
  spinnerType = SPINNER.circle;
  public submitted = false;
  constructor(
    private ngxService: NgxUiLoaderService,public fb: FormBuilder, public authenticationService: AuthenticationService,  public router: Router) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }
  get f() { return this.form.controls; }
  public onSubmit(values: Object): void {
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }
    if (this.form.valid) {
      let email = this.form.get('email').value
      let obj = {email: email, role:"Merchant"}
      this.ngxService.start();
      this.authenticationService.forgotPassword(obj).subscribe(
        (response:any) => {
          this.ngxService.stop();
          let data = response['data'];
          let obj = {requestToken: data.requestToken, email:email}
          localStorage.setItem('requestToken', JSON.stringify(obj))
          this.router.navigate(["/reset-password"]);
          Swal.fire('', 'OTP Sent Sucessfully', 'success')
        },
        error => {
          this.ngxService.stop();
          if (error) {
            Swal.fire('Error',  error.error.message, "error")
          }
        }
      );
    }
  }

  backButton(){
    this.router.navigate(["/login"]);
  }
}
